import { Close, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface SearchFieldProps {
  search: string;
  handleSearch(value: string): void;
}

export const Searchfield = ({ handleSearch, search }: SearchFieldProps) => {
  const { t } = useTranslation();

  return (
    <TextField
      size="small"
      onChange={e => handleSearch(e.target.value)}
      label={t(translations.common.search())}
      value={search}
      defaultValue={search}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={e => handleSearch('')} edge="end">
                <Close />
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
};
